/*
Lista de atributos válidos:
data-panel="8aad5a4df2e94bf087731075a657d45e" : Informa o id do painel que deve ser carregado
data-filter= user|detail|context|master  : Informa o tipo de painel
data-detail-column="true"         : Informa que os detalhes são uma segunda coluna do painél
data-hide-selector="true"         : Informa se esconde a seleção de painéis, não permitindo o usuário escolher outro painél 
data-filter-required="false"      : Informa se os campos filtro são requeridos para renderização do painél
data-filter-master-id="id"        : Informa o id do painel pai, que contem os filtros para o painel 

data-state = "Minimized"          : Estado inicial do painel, se o painel é renderizado minimizado inicialmente 
data-remove = "true"              : Informa se o painel pode ser removido
data-titleMinimize = "true"       : Informa se o click no titulo minimiza o painel
Exemplos:

 <div class="aga-dash-panel"
        data-filter="user"
        data-detail-column="true"
        data-panel="8aad5a4df2e94bf087731075a657d45e"
        data-hide-selector="true"
        data-filter-required="false">
    </div>

    <div class="aga-dash-panel"
        data-filter="user"
        data-filter-required="false"
        data-detail-column="true">
    </div>
*/

"use strict";

AGADash = (function () {

    var widgetsInited = [];
    var currentId = 0;

    return {
        initGrid: function (widgetId, entityId) {

            var linhas = "#" + widgetId + " tr";
            $(linhas).each(function (index, linha) {
                if (index > 0) {
                    var handle = $(linha).attr("handle");
                    var td = document.createElement("td");
                    td.className = "text-right";
                    var a = document.createElement("a");
                    $(a)
                        .attr("onclick",
                            "javascript:AGADash.showModal(" + entityId + ", " + handle + ");event.stopPropagation();");
                    $(a).appendTo(td);
                    var iElement = document.createElement("i");
                    $(iElement).addClass("fa fa-bar-chart").appendTo(a);

                    $(linha).append(td);
                } else {
                    var th = document.createElement("th");
                    th.className = "text-right";
                    $(linha).append(th);
                }
            });

            // Colocar um callback para garantir ajuste após ajax
            var inited = false;
            for (var i = 0; i < widgetsInited.length; i++) {
                if (widgetsInited[i] === widgetId)
                    inited = true;
            }

            if (!inited) {

                var prm = window.Sys.WebForms.PageRequestManager.getInstance();
                if (!prm.get_isInAsyncPostBack()) {
                    prm.add_endRequest(function () { AGADash.initGrid(widgetId, entityId); });
                }
                widgetsInited.push(widgetId);
            }
        },

        initForm: function (widgetId, entityId) {
            var sel = "#" + widgetId + ' [data-field="HANDLE"]';
            var handle = $(sel).val();
            if (!handle || (parseInt(handle) <= 0))
                return;

            var onClick = "javascript:AGADash.showModal(" + entityId + ", " + handle + ");event.stopPropagation();";
            var link = document.createElement("a");
            $(link).attr("onclick", onClick).css("margin-left", "5px");
            var i = document.createElement("i");
            $(i).addClass("fa fa-bar-chart").appendTo(link);

            var portlet = $("#" + widgetId).closest(".portlet");
            $(portlet).find(".caption-subject").first().append(link);
        },

        showModal: function (entityId, handle) {
            var target = $("#Wes2008ApplicationPath").val() + "aga/e/dashboard/modal.aspx?imp=1&ent=" + entityId + '&handle=' + handle;
            Benner.ModalPage.show({
                id: "aga-dash",
                size: "large",
                height: 750,
                displayFooter: false,
                displayTitle: false,
                url: target,
                title: "Dashboard"
            },
            Benner.WidgetCommandsBar.openModal,
            Benner.WidgetCommandsBar.disposeModal);
        },

        initAll: function () {
            $(".aga-dash-panel").each(function (idx, obj) {
                AGADash.Panel.init(obj);
            });
        },

        appUrl: function () {
            return $("#Wes2008ApplicationPath").val();
        },

        serviceUrl: function () {
            return $("#Wes2008ApplicationPath").val() + "api/AGADash";
        },

        callService: function (method, data, successCallback, errorCallback) {
            $.ajax({
                url: AGADash.serviceUrl() + method,
                data: data,
                dataType: "json",
                success: successCallback,
                error: errorCallback
            });
        },

        callPrintService: function (data) {
            var url = $("#Wes2008ApplicationPath").val() + "api/AGADashPrint";

            var b = $("body");

            App.blockUI({
                target: b,
                animate: true,
                overlayColor: "none"
            });

            $.ajax({
                method: "POST",
                url: url,
                data: JSON.stringify(data),
                contentType: "application/json",
                success: function () {
                    App.unblockUI(b);
                    Benner.AsyncProcesses.requestAsyncProcesses(500);

                },
                error: function () {
                    App.unblockUI(b);
                    alert("Não foi possível emitir o relatório.");
                }
            });
        },

        getUniqueId: function () {
            currentId++;
            return "aga_uid_" + currentId.toString();
        }
    };

})();

// Inicializar no load do documento
$(document).ready(function () { AGADash.initAll(); });